<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="10">
        <template v-if="$store.getters.loadedActiveTribune">
          <v-card>
            <v-img></v-img>
            <v-card-title>
              {{ tribune.name }}
              <v-spacer>
              </v-spacer>
              <v-btn color="#1f51a4" link :href="tribune.zoomLink" :disabled="!activator.isTime">
                <span class="white--text">ZOOM</span>
              </v-btn>
            </v-card-title>
            <v-card-subtitle>Время конференции: <strong>{{ tribuneDate }}</strong></v-card-subtitle>
            <s-info v-if="!activator.startSpeech" :person="tribune.speaker" :speech="tribune.speech">
            </s-info>
            <v-card-actions v-if="!activator.startSpeech">
              <v-spacer></v-spacer>
              <v-btn class="mt-4 mb-4" color="#ec1946" x-large :disabled="!activator.isTime" @click="activator.startSpeech = true">
                <span class="white--text">Дать старт выступлению</span>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <template v-if="activator.startSpeech">
            <speech :speech="tribune.speech.speech"></speech>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mt-4 mb-4" color="#ec1946" x-large @click="activator.openRate = true">
                <span class="white--text">Оценить выступление</span>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-snackbar color="success" :timeout="3000" v-model="activator.sendRate" >Отзыв успешно отправлен</v-snackbar>
            <v-dialog max-width="800" v-model="activator.openRate">
              <rating @rate="rateSpeaker"></rating>
            </v-dialog>
          </template>
        </template>
        <template v-else-if="activator.errorLoad">
          <v-snackbar color="error" top :timeout="2000" v-model="activator.errorLoad">
            Трибуна не найдена...<br>
            Вы вернётесь на страницу поиска
          </v-snackbar>
        </template>
        <template v-else>
          <v-card>
            <v-card-title>Загрузка...</v-card-title>
          </v-card>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SInfo from '../components/tribune/SInfo'
import Speech from '../components/tribune/Speech'
import Rating from '../components/tribune/Rating'
export default {
  name: 'TribuneRoom',
  components: {
    Rating,
    Speech,
    SInfo
  },
  props: {
    tribuneName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      activator: {
        errorLoad: false,
        isTime: false,
        startSpeech: false,
        openRate: false,
        sendRate: false
      }
    }
  },
  computed: {
    tribune: ({ $store }) => {
      return $store.getters.ActiveTribune
    },
    tribuneDate: ({ tribune }) => {
      const date = new Date(tribune.start)
      return date.toLocaleString('ru', {
        hour: 'numeric',
        minute: 'numeric',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        weekday: 'long'
      })
    }
  },
  methods: {
    async rateSpeaker (context) {
      const comment = context.Comment
      const Rate = {}
      const criterion = context.Criterion
      for (const c of criterion) {
        const newC = {}
        for (const i of c.items) {
          newC[i.type] = i.rate
        }
        Rate[c.type] = newC
      }
      try {
        await this.$store.dispatch({
          type: 'rateSpeech',
          rating: {
            comment: comment,
            rate: Rate
          }
        })
        this.activator.sendRate = true
        this.activator.openRate = false
      } catch {
        alert('Оценка не отправлена')
      }
    }
  },
  async created () {
    try {
      await this.$store.dispatch({
        type: 'getTribune',
        tribuneName: this.tribuneName
      })
      this.activator.isTime = (new Date(this.tribune.start)) < Date.now()
    } catch {
      this.activator.errorLoad = true
      setTimeout(() => {
        this.$router.push({
          name: 'Tribune'
        })
      }, 2000)
    }
  },
  destroyed () {
    this.$store.commit({
      type: 'leaveTribune'
    })
  }
}
</script>

<style scoped>

</style>
